import React from 'react';
import Sidebar from '../components/Sidebar';
import Profile from '../components/Dashboard/profile'
import DealTable from '../components/DealTable'
const Deal = () => {
  return (
    <>
    <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        html, body {
          height: 100%;
          font-family: 'Open Sans', sans-serif;
        }
        main {
          flex: 1;
          overflow-y: auto;
        }
      `}</style>
      
      <div style={{ display: 'flex', height: '100vh' }}>
      <Sidebar />

      <main style={{ flex: 1, padding: '0px', overflowY: 'auto' }}>
      
        <Profile />
        <DealTable />
      </main>
    </div>
      </>
  );
};

export default Deal;
